// extracted by mini-css-extract-plugin
export default {"content":"Una-z","title":"Vna-z","subTitle":"Wna-z","banner":"Xna-z","productCardOverride":"Yna-z"};